import { c as _c } from "react/compiler-runtime";
import type { PreferencesClientMessage } from '@repo/map-preferences/types';
import { useAppDispatch, useAppSelector, useAppStore } from '@repo/store/maps/hooks';
import { selectFogOfWarActive, selectLocationEnabled, selectMapData, selectPlayerCoords, selectPlayerLocationDeltas } from '@repo/store/maps/slices/mapData';
import { gameCoordsToLatLng } from '@repo/types/maps/map-utils';
import type * as MapLibre from 'maplibre-gl';
import { type MutableRefObject, useCallback, useEffect, useRef } from 'react';
import { executeFogRevealAtLatLng } from './execute-fog-reveal-at-lat-lng';
export interface FogRevealAtLatLngOptions {
  trustLivePosition?: boolean;
}
export function useFogOfWarSampler(sendMessageRef) {
  const $ = _c(16);
  const dispatch = useAppDispatch();
  const store = useAppStore();
  const enabled = useAppSelector(selectFogOfWarActive);
  const locationEnabled = useAppSelector(selectLocationEnabled);
  const playerCoords = useAppSelector(selectPlayerCoords);
  const playerLocationDeltas = useAppSelector(selectPlayerLocationDeltas);
  const mapDataLoaded = useAppSelector(selectMapData);
  const lastSampledRef = useRef(null);
  let t0;
  if ($[0] !== dispatch || $[1] !== sendMessageRef || $[2] !== store) {
    t0 = (latLng, options) => {
      executeFogRevealAtLatLng(latLng, {
        dispatch,
        getState: () => store.getState(),
        lastSampledRef,
        sendMessageRef,
        trustLivePosition: options?.trustLivePosition
      });
    };
    $[0] = dispatch;
    $[1] = sendMessageRef;
    $[2] = store;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const fogRevealAtLatLng = t0;
  let t1;
  let t2;
  if ($[4] !== dispatch || $[5] !== enabled || $[6] !== locationEnabled || $[7] !== mapDataLoaded || $[8] !== playerCoords || $[9] !== playerLocationDeltas || $[10] !== sendMessageRef || $[11] !== store) {
    t1 = () => {
      if (!enabled) {
        lastSampledRef.current = null;
        return;
      }
      if (!mapDataLoaded || !locationEnabled || !playerCoords || !playerLocationDeltas) {
        return;
      }
      const latLng_0 = gameCoordsToLatLng(playerCoords, playerLocationDeltas.deltas);
      if (!latLng_0) {
        return;
      }
      const prev = lastSampledRef.current;
      if (prev && prev.distanceTo(latLng_0) < 0.0001) {
        return;
      }
      executeFogRevealAtLatLng(latLng_0, {
        dispatch,
        getState: () => store.getState(),
        lastSampledRef,
        sendMessageRef,
        trustLivePosition: false
      });
    };
    t2 = [mapDataLoaded, enabled, locationEnabled, playerCoords, playerLocationDeltas, dispatch, store, sendMessageRef];
    $[4] = dispatch;
    $[5] = enabled;
    $[6] = locationEnabled;
    $[7] = mapDataLoaded;
    $[8] = playerCoords;
    $[9] = playerLocationDeltas;
    $[10] = sendMessageRef;
    $[11] = store;
    $[12] = t1;
    $[13] = t2;
  } else {
    t1 = $[12];
    t2 = $[13];
  }
  useEffect(t1, t2);
  let t3;
  if ($[14] !== fogRevealAtLatLng) {
    t3 = {
      fogRevealAtLatLng
    };
    $[14] = fogRevealAtLatLng;
    $[15] = t3;
  } else {
    t3 = $[15];
  }
  return t3;
}